import type { ReactNode } from 'react';
import { createContext } from 'react';

export type PageSidebarSlot = {
  content: ReactNode;
  appearance?: {
    bgcolor?: string;
    borderColor?: string;
  };
};

interface PageLayoutSlots {
  pageHeaderSlot: ReactNode;
  pageSidebarSlot: PageSidebarSlot | null;
}

interface PageLayoutActions {
  setPageHeaderSlot: (node: ReactNode) => void;
  setPageSidebarSlot: (slot: PageSidebarSlot | null) => void;
}
// For reading slot content (used by layout components)
export const PageLayoutSlotContext = createContext<PageLayoutSlots>({
  pageHeaderSlot: null,
  pageSidebarSlot: null,
});

// For writing slot content (used by pages via hooks)
export const PageLayoutContext = createContext<PageLayoutActions>({
  setPageHeaderSlot: () => {},
  setPageSidebarSlot: () => {},
});
